// import React from "react";
import React from "react";
import {
  Image,
  Linking,
  ScrollView,
  StyleSheet,
  Text,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import ViewShot, { captureRef } from "react-native-view-shot";

import WhatsAppIcon from "@assets/svg/WhatsappSmall";

import WAShareOrder from "@components/WAShareOrder";
import CartIcon from "@assets/svg/Cart";
import colors from "@constants/color";
import metrics from "@constants/metrics";

import LinearGradient from "react-native-linear-gradient";
import analytics from "@services/analytics";
import t from "@constants/localization";
import { scale, verticalScale } from "../../utils/scale";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import { CUSTOMER_PAGE } from "../../constants/analyticsEventsCT";

const PATH = "screens/CustomerProfile/CartComponent";

export const showLimitedImages = (imgs = [], limit = 3) => {
  if (!imgs.length || limit <= 0) {
    return;
  }
  const totalImages = imgs.length;

  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <>
      {toShowOnlyArr.map((imageUrl, imageIndex) => (
        <Image
          resizeMode="contain"
          key={imageIndex}
          source={{ uri: imageUrl }}
          style={styles.image}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text style={{ fontSize: 14, lineHeight: 20, color: "black" }}>
            +{+totalImages - limit}
          </Text>
        </View>
      )}
    </>
  );
};

const CartComponent = (props) => {
  const {
    item = {},
    navigateToDetails = () => {},
    phone = "",
    onWaShare = () => {},
    amount = 0,
    name = "",
    num_items = "",
    waText = false,
    images = [],
    cartShare = "",
  } = props;
  const {
    order_id = "",

    user_phone = "",

    share_message = "",

    order_level = 0,

    user_id = "",
  } = item;
  const viewShotRef = React.useRef();
  const captureAndShare = () => {
    viewShotRef.current.capture().then(async (uri) => {
      shareOnWhatsapp({
        message: cartShare || "",
        image: uri,
        phoneNumber: phone,
      });
    });
    analytics.trackEvent(CUSTOMER_PAGE.CX_DETAIL_SHARE_CART, {
      cx_id: user_id,
    });
  };
  const shouldAskForRating = order_level === 4;
  return (
    <View style={styles.main_container}>
      <ViewShot
        style={styles.imageBackground}
        ref={viewShotRef}
        options={{ format: "jpg", quality: 0.9 }}
      >
        <LinearGradient
          start={{ x: 0.0, y: 0.3 }}
          end={{ x: 0.9, y: 0.9 }}
          colors={["#28D883", "#007972"]}
        >
          <TouchableNativeFeedback
            onPress={() => navigateToDetails(order_id)}
            background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
          >
            <View style={styles.orderCardContainer}>
              <View style={styles.topContainer}>
                <View style={styles.orderIdContainer}>
                  <View style={{ marginTop: verticalScale(2) }}>
                    <CartIcon color="white" height={16} width={16} />
                  </View>
                  <Text
                    style={{
                      marginLeft: scale(7),
                      fontSize: scale(16),
                      color: "white",
                      fontWeight: "700",
                    }}
                  >
                    {name + t(`${PATH}/cart`)}
                  </Text>
                </View>
              </View>

              <View style={{ marginTop: 20, flexDirection: "row" }}>
                <Text
                  style={{
                    flex: 1,
                    fontSize: scale(16),
                    color: colors.white,
                  }}
                >
                  {num_items}
                </Text>
                <Text
                  style={{
                    fontSize: scale(16),
                    color: colors.white,
                    fontWeight: "700",
                  }}
                >
                  ₹{amount}
                </Text>
              </View>
              <ScrollView
                horizontal
                contentContainerStyle={styles.imageContainer}
              >
                {images.length > 0 && showLimitedImages(images, 4)}
              </ScrollView>

              <View style={styles.deliveryContainer}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <Text
                    style={{
                      color: "white",
                      fontSize: scale(14),
                      flex: 0.6,
                    }}
                  >
                    {t(`${PATH}/askToCompleteOrder`, { name })}
                  </Text>
                  <View style={{ flex: 0.4 }} />
                </View>
              </View>
            </View>
          </TouchableNativeFeedback>
        </LinearGradient>
      </ViewShot>

      <TouchableOpacity
        onPress={() => {
          captureAndShare();
          // onWaShare(share_message, user_phone, order_id);
        }}
        style={styles.waContainer}
      >
        <WAShareOrder
          // order={order}
          waText={waText}
          icon={<WhatsAppIcon style={{ marginRight: 10 }} />}
          textColor={colors.lightBlack}
          buttonStyles={styles.waButton}
          textStyles={{ color: "white", fontWeight: "bold", fontSize: 16 }}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  main_container: {
    position: "relative",
  },
  orderCardContainer: {
    // backgroundColor: "red",
    flexDirection: "column",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginVertical: 5,
    backgroundColor: "transparent",
  },
  orderIdContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  topContainer: {
    // backgroundColor: "pink",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  imageContainer: {
    height: 70,
    overflow: "visible",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  image: {
    marginRight: 15,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
  },
  nMoreBox: {
    height: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  namePriceContainer: {
    // backgroundColor: "teal",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  whatsappContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  namePriceText: {
    fontSize: 16,
    fontWeight: "bold",
    lineHeight: 22,
    color: colors.mediumBlack,
  },
  phonePaymentContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deliveryContainer: {
    flex: 1,
    paddingBottom: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 5,
  },
  dotContainer: {
    height: 8,
    width: 8,
    backgroundColor: colors.lightBlack,
    borderRadius: 4,
    marginRight: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  waShareButton: {
    width: metrics.screenWidth * 0.1,
    marginRight: 10,
  },
  buttonsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 20,
  },
  waContainer: {
    borderRadius: 6,
    borderWidth: 1,
    width: scale(140),
    position: "absolute",
    right: 15,
    bottom: 20,
    borderColor: "white",
    paddingVertical: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  groupBuyOrderContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default CartComponent;
